import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { CurrencyProvider } from "@/context/CurrencyContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Landing from "@/pages/Landing";
import AdultsHome from "@/pages/AdultsHome";
import KidsHome from "@/pages/KidsHome";
import Companies from "@/pages/Companies";
import Courses from "@/pages/Courses";
import CourseDetail from "@/pages/CourseDetail";
import Flagship from "@/pages/Flagship";
import Founder from "@/pages/Founder";
import Auth from "@/pages/Auth";
import AuthCallback from "@/pages/AuthCallback";
import Dashboard from "@/pages/Dashboard";
import AdminDashboard from "@/pages/AdminDashboard";
import PaymentReturn from "@/pages/PaymentReturn";
import Legal from "@/pages/Legal";
import Contact from "@/pages/Contact";
import ResetPassword from "@/pages/ResetPassword";
import NotFound from "@/pages/NotFound";
import OneOnOne from "@/pages/OneOnOne";
import Workshop from "@/pages/Workshop";
import InviteSankalp from "@/pages/InviteSankalp";

function ThemeBody() {
  const loc = useLocation();
  useEffect(() => {
    document.title = "Code With Sankalp — Learn to Code";
  }, []);
  useEffect(() => {
    if (loc.pathname.startsWith("/kids")) document.body.classList.add("kids-theme");
    else document.body.classList.remove("kids-theme");
  }, [loc.pathname]);
  return null;
}

function AppRouter() {
  const loc = useLocation();
  if (loc.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <>
      <ThemeBody />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/adults" element={<AdultsHome />} />
        <Route path="/kids" element={<KidsHome />} />
        <Route path="/companies" element={<Companies />} />
        <Route path="/courses" element={<Courses />} />
        <Route path="/courses/:id" element={<CourseDetail />} />
        <Route path="/flagship" element={<Flagship />} />
        <Route path="/founder" element={<Founder />} />
        <Route path="/about" element={<Founder />} />
        <Route path="/meet-sankalp" element={<Founder />} />
        <Route path="/meet-sankalp/1-on-1" element={<OneOnOne />} />
        <Route path="/workshops/:slug" element={<Workshop />} />
        <Route path="/invite-sankalp" element={<InviteSankalp />} />
        <Route path="/login" element={<Auth mode="login" />} />
        <Route path="/signup" element={<Auth mode="signup" />} />
        <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
        <Route path="/admin" element={<ProtectedRoute requireAdmin><AdminDashboard /></ProtectedRoute>} />
        <Route path="/payment/return" element={<PaymentReturn />} />
        <Route path="/privacy" element={<Legal doc="privacy" />} />
        <Route path="/terms" element={<Legal doc="terms" />} />
        <Route path="/refund-policy" element={<Legal doc="refund" />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/forgot-password" element={<ResetPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <CurrencyProvider>
        <AuthProvider>
          <AppRouter />
          <Toaster position="top-right" richColors closeButton />
        </AuthProvider>
      </CurrencyProvider>
    </BrowserRouter>
  );
}
